module.exports = "<div class=\"member-container-outside clearfix\">\n  <main class=\"member-container\">\n    <div class=\"member-container-gray\" *ngIf=\"!isMobile\"></div>\n    <section class=\"info-wrap\" *ngIf=\"!isMobile\">\n      <app-myinfo></app-myinfo>\n    </section>\n    <section class=\"content-wrap\" [class.no-padding]=\"noPadding\" [style.min-height.px]=\"innerHeight\">\n      <router-outlet></router-outlet>\n    </section>\n  </main>\n</div>\n\n<app-message-modal></app-message-modal>\n<app-profile-modal></app-profile-modal>"


//////////////////
// WEBPACK FOOTER
// ./src/app/member/member.component.html
// module id = 1113
// module chunks = 0